import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { toast } from 'sonner'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Fetches a member's conversations by member ID. Shows a toast on failure. */
export function useListMemberConversations(memberId: string, enabled = true) {
  const api = useOsApi()

  const query = useQuery({
    queryKey: ['member-conversations', memberId],
    enabled,
    retry: false,
    queryFn: async () => {
      const response = await api.get('/members/:memberId/conversations', { params: { memberId } })
      if (!response.success) throw new Error(response.error.message)
      return response.data
    },
  })

  useEffect(() => {
    if (query.error) {
      toast.error('Failed to load conversations')
    }
  }, [query.error])

  return query
}
